import { Box, Collapse, Flex, Text } from '@chakra-ui/react'

import { useLogoutTimerContext } from '@/context/LoginTimerProvider'


export const LogoutTimer = () => {
  const { visible, minutes, seconds, isLoggingOut } = useLogoutTimerContext()

  return (
    <Box sx={{ position: 'relative' }}>
      <Collapse
        startingHeight={0}
        endingHeight={'4em'}
        transition={{ enter: { duration: 0.5 }, exit: { duration: 0.3 } }}
        in={visible}
        style={{ width: '100%' }}
      ></Collapse>
      <Collapse
        startingHeight={0}
        endingHeight={'4em'}
        transition={{ enter: { duration: 0.5 }, exit: { duration: 0.3 } }}
        in={visible}
        style={{ zIndex: 9999, position: 'fixed', top: 0, width: '100%' }}
      >
        <Flex
          sx={{
            w: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'red.100',
            h: '4em',
            gap: { sm: 6, base: 1 }
          }}
        >
          {isLoggingOut ?
            <Text fontSize={'xl'} textColor={'red.700'}>
              Probíhá automatické odhlášení.
            </Text>
            :
            <Text fontSize={'xl'} textColor={'red.700'}>
              Zbývá{' '}
              <b>
                {minutes}:{seconds}
              </b>{' '}
              do automatického odhlášení.
            </Text>
          }
        </Flex>
      </Collapse>
    </Box>
  )
}
